/**
 * Shared width for Settings “add” flows: 20% wider than `max-w-md` (28rem → 33.6rem).
 * Use on DialogContent or centered modal shells.
 *
 * Vertical spacing: `@/lib/product-dialog-layout` (`productDialogFormClassName`, etc.).
 */
export const settingsAddModalMaxWidthClassName = "max-w-[min(33.6rem,calc(100vw-2rem))]";
